import React from 'react'
import './DeleteConfirmationModal.css'

function DeleteConfirmationModal({ lesson, onClose, onConfirm, isDeleting }) {
  return (
    <div className="modal-overlay">
      <div className="delete-modal-content">
        <div className="delete-modal-header">
          <div className="delete-modal-icon">⚠️</div>
          <h3>Delete Lesson</h3>
        </div>
        
        <div className="delete-modal-body">
          <p className="delete-modal-message">
            Are you sure you want to delete <strong>"{lesson.lessonName}"</strong>?
          </p>
          <p className="delete-modal-warning">
            This action cannot be undone.
          </p>
          <div className="delete-modal-info">
            <div className="delete-info-item">
              <span className="delete-info-label">Lesson Key:</span>
              <code className="delete-info-value">{lesson.lessonKey}</code>
            </div>
            <div className="delete-info-item">
              <span className="delete-info-label">File:</span>
              <span className="delete-info-value">{lesson.fileDisplayName}</span>
            </div>
          </div>
        </div>
        
        <div className="delete-modal-actions">
          <button
            type="button"
            className="delete-cancel-btn"
            onClick={onClose}
            disabled={isDeleting}
          >
            Cancel
          </button>
          <button
            type="button"
            className="delete-confirm-btn"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'Deleting...' : 'Delete Lesson'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default DeleteConfirmationModal



